import React from "react";
import { Button } from "../../";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    icon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    success: {
      color: theme.palette.primary.main,
      fontSize: "76px",
      margin: "26px"
    },
    warning: {
      color: theme.palette.pending,
      fontSize: "76px",
      margin: "26px"
    },
    error: {
      color: theme.palette.secondary.main,
      fontSize: "76px",
      margin: "26px"
    }
  };
});

var Alert = function Alert(props) {
  // console.log("alert props", props);
  var classes = useStyles();
  var buttonSuccess = props.onSubmit ? /*#__PURE__*/React.createElement(Button, {
    onClick: props.onSubmit,
    color: "primary",
    variant: "outline"
  }, props.submit) : null;
  var buttonLink = props.link ? /*#__PURE__*/React.createElement(Link, {
    to: props.link
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "outline"
  }, props.linkText)) : null;
  var icon;

  switch (props.status) {
    case "success":
      icon = /*#__PURE__*/React.createElement("div", {
        className: classes.icon
      }, /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, {
        className: classes.success
      }));
      break;

    case "warning":
      icon = /*#__PURE__*/React.createElement("div", {
        className: classes.icon
      }, /*#__PURE__*/React.createElement(ErrorOutlineIcon, {
        className: classes.warning
      }));
      break;

    case "error":
      icon = /*#__PURE__*/React.createElement("div", {
        className: classes.icon
      }, /*#__PURE__*/React.createElement(HighlightOffIcon, {
        className: classes.error
      }));
      break;

    default:
      break;
  }

  return /*#__PURE__*/React.createElement(Dialog, {
    open: props.open,
    onClose: props.onClose
  }, /*#__PURE__*/React.createElement(DialogTitle, null, props.title), /*#__PURE__*/React.createElement(DialogContent, null, icon, props.text && /*#__PURE__*/React.createElement(DialogContentText, null, props.text)), /*#__PURE__*/React.createElement(DialogActions, null, buttonSuccess, buttonLink));
};

export { Alert };